<template>
  <div class="title-container" :style="titleContainer" ref="titleContainer">
    <div class="title-box" :style="titleBoxStyl">
      <p class="main-title" :style="mainTitle" ref="mainTitle">{{ receiveProps.tempData.titleContentData.titleName }}</p>
      <p class="half-title" :style="halfTitle" ref="halfTitle">{{ receiveProps.tempData.titleContentData.titleDes }}</p>
    </div>
    <div class="link-box">
      <span @click="clickLink">{{ receiveProps.tempData.titleContentData.titleUrl }}</span>
    </div>
  </div>
</template>

<script>
import { commonClickFn } from '../block/componentArticle/commonModuleFn'
export default {
    name: 'titleBar',
    props:{
       receiveProps: {
           type: Object,
           default: ()=>{}
       }
    },
    computed:{
        titleContainer(){
          let {blockMargeTop, blockMargeBottom, blockBGClolor} = this.receiveProps.tempData.specialStyle
            return {
              '--all-margin-top': `${blockMargeTop}px`,
              '--all-margin-bottom': `${blockMargeBottom}px`,
              '--all-background-color': blockBGClolor
            }
        },
        titleBoxStyl(){
          let {titleAlign } = this.receiveProps.tempData.specialStyle
          return {
            "--title-link-padding": titleAlign == 'right'?'120px': ''
          }
        },
        mainTitle(){
            let {titleAlign, titleBold, titleColor, titleSize} = this.receiveProps.tempData.specialStyle
            return {
                '--main-font-color': titleColor,
                '--main-font-size': `${titleSize || 24}px`,
                '--main-font-weight': titleBold? '700': '',
                '--main-text-align': titleAlign,
            }
        },
        halfTitle(){
            let {descSize, descColor, descBold, descAlign} = this.receiveProps.tempData.specialStyle
            return {
                '--half-font-color': descColor,
                '--half-font-size': `${descSize || 14}px`,
                '--half-font-weight': descBold? '700': '',
                '--half-text-align': descAlign,
            }
        }

    },
  data() {
    return {
      titleContentData: this.receiveProps.tempData.titleContentData,
      specialData: this.receiveProps.tempData.specialData
    };
  },
  mounted(){
    console.log('----=====>', this.receiveProps)
  },
  methods: {
    clickLink(){
      commonClickFn(this.titleContentData, this.specialData, this, true)
      // let { openModel, selectUrlType, freedomPageUrl, systemPageUrl, linkUrl, articleId, classId } = this.receiveProps.tempData.titleContentData;
      // if(!selectUrlType) return
      // let skipUrl = ''
      // switch(selectUrlType){
      //   case 1: skipUrl = this.$router.resolve({
      //         path:  '/cms/detail',
      //         query: {
      //           articleId: articleId
      //         },
      //       })
      //       break;
      //   case 2: skipUrl = freedomPageUrl
      //           break;
      //   case 3: skipUrl = systemPageUrl
      //           break;
      //   case 4: skipUrl = linkUrl
      //           break;
      //   case 5: skipUrl = this.$router.resolve({
      //         path:  '/cms/list',
      //         query: {
      //           classId: classId
      //         },
      //       })
      //       break;
      // }
      // let routerUrl = typeof(skipUrl) == 'object'? skipUrl.href: skipUrl
      // if (openModel == 1) {
      //   window.location.href = routerUrl; // 路由跳转需要结构出href
      //   return;
      // }
      // window.open(routerUrl);
    }
  }
};
</script>

<style lang="less" scoped>
.title-container {
  max-width: 1200px;
  // height: 93px;
  padding: 16px;
  box-sizing: border-box;
  background-color: pink;
  display: flex;
  align-content: center;
  position: relative;
  margin: 0 auto;
  margin-top: var(--all-margin-top);
  margin-bottom: var(--all-margin-bottom);
  background-color: var(--all-background-color);
  .title-box {
    width: 100%;
    padding-right: var(--title-link-padding);
    .main-title{
        margin-bottom: 20px;
        color: var(--main-font-color);
        font-size: var(--main-font-size);
        font-weight: var(--main-font-weight);
        text-align: var(--main-text-align);
    }
    .half-title{
        color: var(--half-font-color);
        font-size: var(--half-font-size);
        font-weight: var(--half-font-weight);
        text-align: var(--half-text-align);
    }
  }
  .link-box {
    height: 20px;
    position: absolute;
    top: 23px;
    right: 16px;
    span:hover{
      cursor: pointer;
    }
  }
}
</style>